module.exports = __webpack_public_path__ + "img/jacket-left-sub-setIn-classic.0382b449.png";